import { render } from "./LoadingState.vue?vue&type=template&id=33288f05&scoped=true"
import script from "./LoadingState.vue?vue&type=script&lang=js"
export * from "./LoadingState.vue?vue&type=script&lang=js"

import "./LoadingState.vue?vue&type=style&index=0&id=33288f05&scoped=true&lang=css"

import exportComponent from "C:\\Users\\PR024\\Desktop\\uzcsd-uz\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-33288f05"]])

export default __exports__